module.exports = "<div class=\"app-body\">\n\n    <ui-view name=\"content\">\n        <h1>Please select the task that you would like to work on</h1>\n    </ui-view>\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./Client/app/tasks/controllers/tasks/tasks.html
// module id = 602
// module chunks = 0